import * as React from 'react'
import {
  Braces as DataTypeIcon,
  CircuitBoard as ControllerIcon,
  Component as DataTypeMemberIcon,
  FileCode2 as ProgramIcon,
  ListTree as RoutineIcon,
  Package as AoiIcon,
  Tag as PlcTagIcon
} from 'lucide-react'
import type { PlantPlcNodeKind } from '@axilon-apps/domains-ontology-ui-state'

type IconComponent = React.ComponentType<{ size?: number | string; className?: string }>

/**
 * Lucide icon assignments per PLC node kind. Used by both the left-rail
 * tree (where each row gets a small kind glyph) and the right-pane
 * detail header. Kept distinct from `compute-icon.ts`'s `CpuIcon` so the
 * PLC tab is visually distinguishable from the Compute tab.
 */
const ICONS_BY_KIND: Record<PlantPlcNodeKind, IconComponent> = {
  Controller: ControllerIcon,
  Program: ProgramIcon,
  Routine: RoutineIcon,
  AOI: AoiIcon,
  PLCDataType: DataTypeIcon,
  PLCDataTypeMember: DataTypeMemberIcon,
  PLCTag: PlcTagIcon
}

export function plcIconFor(kind: PlantPlcNodeKind): IconComponent {
  return ICONS_BY_KIND[kind]
}

const SINGULAR_LABELS: Record<PlantPlcNodeKind, string> = {
  Controller: 'Controller',
  Program: 'Program',
  Routine: 'Routine',
  AOI: 'Add-On Instruction',
  PLCDataType: 'PLC data type',
  PLCDataTypeMember: 'PLC data type member',
  PLCTag: 'PLC Tag'
}

export function plcLabelFor(kind: PlantPlcNodeKind): string {
  return SINGULAR_LABELS[kind]
}
